import { restApiIP } from "@plannel/services/utils/rest-api";

const getTrendAllowance = params => {
  return restApiIP.get("/api/ip/trend-allowance", { params });
};

const upsertTrendAllowance = trendAllowance => {
  return restApiIP.post("/api/ip/trend-allowance", trendAllowance);
};

const ipTrendAllowanceService = {
  getTrendAllowance,
  upsertTrendAllowance
};

export default ipTrendAllowanceService;